import { SettingsPage } from "./Settings.index";
import { useCredentialsWithInfo } from "utils/requests";
import NotFound from "pages/NotFound";
import { useEffect, useState } from "react";

const Settings = () => {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const { data: credentialsWithInfo, isLoading } = useCredentialsWithInfo(
    currentPage,
    pageSize
  );
  useEffect(() => {
    setCurrentPage(0);
  }, []);

  if (!credentialsWithInfo) {
    return <NotFound />;
  }
  // Callbacks for pagination
  const handleNext = () => setCurrentPage(prevPage => prevPage + 1);
  const handlePrevious = () => setCurrentPage(prevPage => Math.max(0, prevPage - 1));
  const handlePageSizeChange = (size: number) => {
    let newPage = Math.floor(
      (currentPage * pageSize + credentialsWithInfo.length) / size
    );
    setPageSize(size);
    setCurrentPage(() => Math.max(0, newPage));
  };

  return (
    <SettingsPage
      credentials={credentialsWithInfo}
      isLoading={isLoading}
      onNextPage={handleNext}
      onPreviousPage={handlePrevious}
      onPageChange={handlePageSizeChange}
    />
  );
};

export default Settings;
